import type { AccessMode } from "@superblocksteam/shared";

import { ReduxActionTypes } from "legacy/constants/ReduxActionConstants";
import type { ReduxAction } from "legacy/constants/ReduxActionConstants";

export const setAccessMode = (payload: AccessMode): ReduxAction<AccessMode> => {
  return {
    type: ReduxActionTypes.SET_USER_MODE,
    payload,
  };
};
